import { DatePipe } from "@angular/common";
import { Component, Inject, OnInit } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from "@angular/material/dialog";
import { forkJoin } from "rxjs";
import { ViewChildren, QueryList, ElementRef, ViewChild, TemplateRef } from "@angular/core";
import { MatExpansionPanel } from "@angular/material/expansion";
import { ToastrService } from "ngx-toastr";
import { ActionTrackerService } from "src/app/shared/services/action-tracker.service";
import { ProjectService } from "src/app/shared/services/project.service";
import { IncidentTrackerService } from "src/app/shared/services/incident-tracker.service";
import textConfiguration from "src/assets/static-text-configuration.json";
import { DeletePopupComponent } from "../../delete-popup/delete-popup.component";
import { RiskConvergenceService } from "src/app/shared/services/risk-convergence.service";
import { CommonService } from "src/app/shared/services/common.service";
@Component({
  selector: "app-risklog-dialog",
  templateUrl: "./risklog-dialog.component.html",
  styleUrls: ["./risklog-dialog.component.scss"],
  providers: [DatePipe],
})
export class RisklogDialogComponent implements OnInit {
  @ViewChildren(MatExpansionPanel) panels!: QueryList<MatExpansionPanel>;
  @ViewChildren("panelElement", { read: ElementRef })
  panelElements!: QueryList<ElementRef>;
  commonText: any = (textConfiguration as any).common;
  riskMetric: any;
  res: any;
  riskMetricCreateForm: any;
  riskMetricAcceptCreateForm: any;
  riskMetricTranferCreateForm: any;
  projectId: any;
  riskOwners: any;
  breadCrumbData: any = [];
  riskStatus: any = [];
  deletedMitigationIds: number[] = [];
  mitigationFunctions: any = [];
  actionFileList: { [key: number]: any[] } = {};
  projectDetails: any;
  uploadFiles: Array<any> = [];
  uploadedFiles: Array<any> = [];
  functionOwners: (string | null)[] = [];
  delegatedUsersList: any[] = [];
  delegatedUserNameMap: { [email: string]: string } = {};
  userDetails: any;
  projectOwner: boolean = false;
  acceptCheckboxChecked: boolean = false;
  showCheckboxError: boolean = false;
  mitigateCheckboxChecked: boolean = false;
  showMitigateCheckboxError: boolean = false;
  mitigateStatusId: any = null;
  approvalComments: string = '';
  isLoaded = false;
  preventiveControls: any;
  detectiveControls: any;
  deletedControlIds: number[] = [];
  riskImpactList: any[] = [];
  riskLikelihoodList: any[] = [];
  selectedRiskImpact: any = null;
  selectedRiskLikelihood: any = null;
  inherentRiskScore: number | null = null;
  selectedResidualImpact: any = null;
  selectedResidualLikelihood: any = null;
  residualRiskScore: number | null = null;
  showResidualSection: boolean = false;
  riskControlOptions: any[] = [];
  riskControlTypes: any[] = [];
  actionCommentsMap: { [key: number]: string } = {};
  selectedApprovalAction: 'Accepted' | 'Rejected' | null = null;

  @ViewChild('historyDialogTemplate') historyDialogTemplate!: TemplateRef<any>;

  constructor(
    public dialogRef: MatDialogRef<RisklogDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public fb: FormBuilder,
    public datepipe: DatePipe,
    private readonly projectService: ProjectService,
    private readonly toastrService: ToastrService,
    private readonly actionTrackerService: ActionTrackerService,
    private readonly incidentTrackerService: IncidentTrackerService,
    private readonly dialog: MatDialog,
    private readonly riskService: RiskConvergenceService,
    private readonly commonService: CommonService
  ) { }

  ngOnInit(): void {
    this.riskMetric = this.data.riskMetric;
    this.res = this.data.res;
    this.breadCrumbData = this.data.breadCrumbData || [];
    this.projectId = this.data.projectId;
    this.riskMetricCreateForm = this.fb.array([]);
    this.preventiveControls = this.fb.array([]);
    this.detectiveControls = this.fb.array([]);
    this.riskMetricCreateForm.clear();
    this.getRiskOwners();
    this.initialiseForm();
    forkJoin({
      impact: this.riskService.getRiskImpactList(),
      likelihood: this.riskService.getRiskLikelihoodList(),
    }).subscribe((res: any) => {
      this.riskImpactList = res.impact || [];
      this.riskLikelihoodList = res.likelihood || [];

      this.setRiskScoreFromRes();
      this.handleRes();
    });
    this.getProjectRiskStatus();
    this.getMitigationFunctions();
    this.getRiskControls();
    this.getRiskControlTypes();
    this.projectDetails = JSON.parse(localStorage.getItem("selectedProject") ?? "{}");
    this.userDetails = JSON.parse(localStorage.getItem("permission") ?? "{}");
    this.projectOwner =
      this.projectDetails.owner.id === this.userDetails.id ||
      this.userDetails.is_superuser;
  }

  getRiskControls() {
    this.riskService
      .getRiskControls(this.riskMetric.id)
      .subscribe((res: any) => {
        this.riskControlOptions = res;
      });
  }

  getRiskControlTypes() {
    this.riskService.getRiskControlTypes().subscribe((res: any) => {
      this.riskControlTypes = res;
    });
  }

  getMitigationFunctions() {
    this.projectService.getMitigationFunctions().subscribe((res: any) => {
      this.mitigationFunctions = res;
    });
  }

  historyDialogRef!: MatDialogRef<any>;

  openHistory() {
    this.historyDialogRef = this.dialog.open(this.historyDialogTemplate, {
      width: '600px',
      maxHeight: '80vh',
      panelClass: 'history-dialog-panel'
    });
  }

  getProjectRiskStatus() {
    this.projectService.getProjectRiskStatus().subscribe((res: any) => {
      this.riskStatus = res;
    });
  }
  getRiskOwners() {
    this.projectService.getRiskOwners().subscribe((getRiskOwner: any) => {
      this.riskOwners = getRiskOwner.users;
    });
  }

  handleRes() {
    this.riskMetricCreateForm.clear();
    this.actionFileList = {};
    this.functionOwners = [];
    this.delegatedUsersList = [];
    this.delegatedUserNameMap = {};
    this.mitigateCheckboxChecked = false;
    this.showMitigateCheckboxError = false;
    this.mitigateStatusId = null;
    this.approvalComments = '';
    this.selectedApprovalAction = null;

    if (this.riskMetric.risk_response === "Mitigate") {
      this.preventiveControls.clear();
      this.detectiveControls.clear();

      const preventive = this.res?.preventive_controls || [];
      const detective = this.res?.detective_controls || [];

      if (preventive.length) {
        preventive.forEach((c: any) => {
          this.preventiveControls.push(this.createControlRow(c));
        });
      } else {
        this.preventiveControls.push(this.createControlRow());
      }

      if (detective.length) {
        detective.forEach((c: any) => {
          this.detectiveControls.push(this.createControlRow(c));
        });
      } else {
        this.detectiveControls.push(this.createControlRow());
      }
      this.res.risk_mitigation.forEach((element: any, index: number) => {
        let ownerVal: any = element.owner?.email || null;

        this.actionFileList[index] =
          element?.risk_mitigation?.action?.files || [];
        this.actionCommentsMap[index] =
          element?.risk_mitigation?.action?.comments || "";
        this.riskMetricCreateForm.push(
          this.fb.group({
            id: [element.id],
            mitigation_task: [element.risk_mitigation.action_tasks],
            due_date: [element.planned_end_date],
            status: [element.status],
            comments: [element.remarks],
            owner: ownerVal,
            function: [element.function?.id || null],
            delegated_to: [element.delegated_to?.email || null],
            type: [element.type?.id || element.type || null],
          })
        );
        if (element.function?.id) {
          this.onFunctionChange(element.function.id, index, false);
        }
      });

      // Pre-tick if the overall mitigate status was previously saved as Closed or Accepted
      const alreadyClosed = this.res?.status?.display_name === 'WIP' || this.res?.status?.display_name === 'Closed';
      this.mitigateCheckboxChecked = alreadyClosed;
      if (alreadyClosed) {
        this.mitigateStatusId = this.res?.status?.id ?? null;
      }
      this.approvalComments = this.res?.approval_comments || '';
    }

    if (this.riskMetric.risk_response === "Accept") {
      this.riskMetricAcceptCreateForm.patchValue({
        comments: this.res.comments,
        status: this.res?.status?.id,
        due_date: this.res?.due_date ? new Date(this.res?.due_date) : null,
      });
      this.uploadedFiles = this.res?.files || [];
      const isClosed = this.res?.status?.display_name === "Closed";
      this.acceptCheckboxChecked = isClosed;
      this.showResidualSection = isClosed;
      if (isClosed) {
        this.selectedResidualImpact = this.selectedRiskImpact;
        this.selectedResidualLikelihood = this.selectedRiskLikelihood;
        this.residualRiskScore = this.inherentRiskScore;
      }
    }
    setTimeout(() => {
      this.isLoaded = true;
    }, 100);
  }

  initialiseForm() {
    this.riskMetricAcceptCreateForm = this.fb.group({
      comments: [""],
      status: [""],
      due_date: [""],
    });
  }

  addMetricItems() {
    if (this.projectOwner) {
      return;
    }
    const index = this.riskMetricCreateForm.length;

    this.functionOwners[index] = "";
    this.delegatedUsersList[index] = [];
    this.riskMetricCreateForm.push(
      this.fb.group({
        id: [null],
        mitigation_task: [""],
        due_date: [""],
        status: ["Open"],
        comments: [""],
        owner: [""],
        function: [""],
        delegated_to: [""],
        type: [null],
      })
    );

    setTimeout(() => {
      const panels = this.panels.toArray();
      const panelEls = this.panelElements.toArray();

      const newPanel = panels[panels.length - 1];
      const newPanelEl = panelEls[panelEls.length - 1];

      if (newPanel && newPanelEl) {
        newPanel.open();

        newPanel.afterExpand.subscribe(() => {
          newPanelEl.nativeElement.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        });
      }
    });
  }

  removeMetric(index: number) {
    if (this.projectOwner) {
      return;
    }
    const item = this.riskMetricCreateForm.at(index).value;
    if (item?.id) {
      this.deletedMitigationIds.push(item.id);
    }
    this.riskMetricCreateForm.removeAt(index);
  }

  downloadFile(fileId: number, fileName: string) {
    this.actionTrackerService.downloadActionTrackerFile(fileId).subscribe(
      (res: any) => {
        const downloadLink = document.createElement("a");
        downloadLink.href = window.URL.createObjectURL(res);
        downloadLink.setAttribute("download", fileName);
        document.body.appendChild(downloadLink);
        downloadLink.click();
        this.toastrService.success("File downloaded successfully");
      },
      () => {
        this.toastrService.error("Unable to download file");
      }
    );
  }

  closeDialog() {
    this.dialogRef.close();
  }

  saveMetric() {
    if (this.riskMetric.risk_response === "Accept") {
      if (!this.projectOwner) {
        return;
      }

      if (!this.acceptCheckboxChecked) {
        this.showCheckboxError = true;
        return;
      }

      this.saveAccept();
      return;
    }

    if (this.riskMetric.risk_response === "Mitigate") {
      if (this.selectedApprovalAction === 'Accepted' && !this.mitigateCheckboxChecked) {
        this.showMitigateCheckboxError = true;
        return;
      }
      this.saveMitigate();
    }
  }

  onFunctionChange(functionId: number, index: number, resetDelegated = true) {
    if (!functionId) return;

    this.riskService.getRiskFunctionOwners(functionId).subscribe((res: any) => {
      const formGroup = this.riskMetricCreateForm.at(index);

      const ownerEmail = res.owner?.email || null;

      const ownerName = res.owner
        ? `${res.owner.first_name} ${res.owner.last_name}`
        : null;

      this.functionOwners[index] = ownerName;
      this.delegatedUsersList[index] = res.delegated_users || [];
      (res.delegated_users || []).forEach((user: any) => {
        this.delegatedUserNameMap[user.email] =
          `${user.first_name} ${user.last_name}`;
      });

      formGroup.patchValue({
        owner: ownerEmail,
        delegated_to: resetDelegated ? null : formGroup.value.delegated_to,
      });
    });
  }

  private validateMitigationTasks(mitigationList: any): boolean {
    if (!mitigationList || mitigationList.length === 0) {
      this.toastrService.error("At least one task is mandatory");
      return false;
    }

    const mandatoryFields: { key: string; label: string }[] = [
      { key: "mitigation_task", label: "Mitigation Task" },
      { key: "function", label: "Function" },
      { key: "delegated_to", label: "Delegated To" },
      { key: "due_date", label: "Due Date" },
      { key: "status", label: "Status" },
    ];

    for (let i = 0; i < mitigationList.length; i++) {
      const element = mitigationList[i];
      const taskLabel = element.mitigation_task?.trim()
        ? `Task ${i + 1} "${element.mitigation_task}"`
        : `Task ${i + 1}`;

      for (const field of mandatoryFields) {
        const value = element[field.key];
        const isEmpty =
          value === null ||
          value === undefined ||
          (typeof value === "string" && value.trim() === "");

        if (isEmpty) {
          this.toastrService.warning(
            `${field.label} is required in ${taskLabel}`
          );
          return false;
        }
      }
    }

    return true;
  }

  saveMitigate() {
    const mitigationList = this.riskMetricCreateForm.value;
    if (!this.validateMitigationTasks(mitigationList)) return;

    const created: any[] = [];
    const updated: any[] = [];

    mitigationList.forEach((element: any) => {
      const formattedDate = this.datepipe.transform(
        element.due_date,
        "yyyy-MM-dd"
      );

      const payload = {
        id: element.id,
        mitigation_task: element.mitigation_task,
        due_date: formattedDate,
        status: element.status,
        comments: element.comments,
        owner: element.owner || null,
        delegated_to: element.delegated_to || null,
        function: element.function || null,
        type: element.type || null,
      };

      if (element.id) {
        updated.push(payload);
      } else {
        created.push(payload);
      }
    });

    const controlsCreated: any[] = [];
    const controlsUpdated: any[] = [];

    this.preventiveControls.value.forEach((ctrl: any) => {
      if (!ctrl.description) return;

      const payload: any = {
        id: ctrl.id,
        description: ctrl.description.description || ctrl.description,
        control_type: "preventive",
        type: ctrl.type,
      };

      // Cases (1) and (2): user picked from dropdown
      if (ctrl.master_risk_control_id !== null) {
        payload.master_risk_control_id = ctrl.master_risk_control_id;
        payload.modified = ctrl.modified;
      }

      if (ctrl.id) {
        controlsUpdated.push(payload);
      } else {
        controlsCreated.push(payload);
      }
    });

    this.detectiveControls.value.forEach((ctrl: any) => {
      if (!ctrl.description) return;

      const payload: any = {
        id: ctrl.id,
        description: ctrl.description.description || ctrl.description,
        control_type: "detective",
        type: ctrl.type,
      };

      // Cases (1) and (2): user picked from dropdown
      if (ctrl.master_risk_control_id !== null) {
        payload.master_risk_control_id = ctrl.master_risk_control_id;
        payload.modified = ctrl.modified;
      }

      if (ctrl.id) {
        controlsUpdated.push(payload);
      } else {
        controlsCreated.push(payload);
      }
    });

    // Resolve status ID
    let finalStatus: any = null;

    if (this.isReadOnlyStatus()) {
      finalStatus = this.res.status.id;
    } else if (this.selectedApprovalAction === 'Accepted') {
      const acceptedStatus = this.riskStatus.find(
        (s: any) => s.display_name === 'WIP'
      );
      finalStatus = acceptedStatus?.id ?? null;
    } else if (this.selectedApprovalAction === 'Rejected') {
      finalStatus = 'Rejected';
    } else {
      const underReviewStatus = this.riskStatus.find(
        (s: any) => s.display_name === 'Under Review'
      );
      finalStatus = underReviewStatus?.id ?? null;
    }

    const postdata = {
      created,
      updated,
      deleted: this.deletedMitigationIds || [],

      controls: {
        created: controlsCreated,
        updated: controlsUpdated,
        deleted: this.deletedControlIds || [],
      },
      risk_impact: this.selectedRiskImpact?.id || null,
      risk_likelihood: this.selectedRiskLikelihood?.id || null,

      residual_risk_impact: this.selectedResidualImpact?.id || null,
      residual_risk_likelihood: this.selectedResidualLikelihood?.id || null,
      residual_risk_score: this.residualRiskScore || null,

      status: finalStatus,
      approval_comments: this.approvalComments || null,

      risk_response: "Mitigate",
    };

    const queryParam = `?risk=${this.riskMetric.risk_id}&project=${this.projectId}`;

    this.projectService
      .setRiskResponse(queryParam, postdata)
      .subscribe((res: any) => {
        this.deletedMitigationIds = [];

        this.deletedControlIds = [];

        this.dialogRef.close({ riskId: this.riskMetric.risk_id, res });
        this.toastrService.success("Risk updated successfully");
      });
  }

  saveAccept() {
    const formValues = { ...this.riskMetricAcceptCreateForm.value };

    if (formValues.due_date) {
      formValues.due_date = this.datepipe.transform(
        formValues.due_date,
        "yyyy-MM-dd"
      );
    }

    const formData = new FormData();

    Object.keys(formValues).forEach((key) => {
      if (formValues[key] !== null && formValues[key] !== undefined) {
        formData.append(key, formValues[key]);
      }
    });

    // attach uploaded files
    if (this.uploadFiles?.length) {
      this.uploadFiles.forEach((file: File) => {
        formData.append("files", file);
      });
    }

    formData.append("risk_response", "Accept");

    if (this.selectedRiskImpact?.id) {
      formData.append("risk_impact", this.selectedRiskImpact.id);
    }

    if (this.selectedRiskLikelihood?.id) {
      formData.append("risk_likelihood", this.selectedRiskLikelihood.id);
    }

    const queryParam = `?risk=${this.riskMetric.risk_id}&project=${this.projectId}`;

    this.projectService
      .setRiskResponse(queryParam, formData)
      .subscribe((res: any) => {
        this.uploadFiles = [];
        this.dialogRef.close({ riskId: this.riskMetric.risk_id, res });
        this.toastrService.success("Risk updated successfully");
      });
  }

  isClosed(): boolean {
    const closedStatus = this.riskStatus.find(
      (s: any) => s.display_name === "Closed"
    );

    return (
      this.riskMetricAcceptCreateForm.get("status")?.value === closedStatus?.id
    );
  }

  isReadOnlyStatus(): boolean {
    return this.res?.status?.display_name === 'Closed' || this.res?.status?.display_name === 'WIP';
  }

  onApprove() {
    this.selectedApprovalAction = 'Accepted';
    this.showMitigateCheckboxError = false;
  }

  onReject() {
    this.selectedApprovalAction = 'Rejected';
    this.mitigateCheckboxChecked = false;
  }

  onUncheck() {
    this.selectedApprovalAction = null;
    this.mitigateCheckboxChecked = false;
  }

  resolveMitigateStatusId(isChecked: boolean) {
    if (isChecked) {
      const closedStatus = this.riskStatus.find(
        (s: any) => s.display_name === 'Closed'
      );
      this.mitigateStatusId = closedStatus?.id ?? null;
    } else {
      this.mitigateStatusId = null;
    }
  }

  toggleStatus(isChecked: boolean) {
    this.acceptCheckboxChecked = isChecked;
    this.showCheckboxError = false;

    const closedStatus = this.riskStatus.find(
      (s: any) => s.display_name === "Closed"
    );

    const openStatus = this.riskStatus.find(
      (s: any) => s.display_name === "Open"
    );

    const statusId = isChecked ? closedStatus?.id : openStatus?.id;

    this.riskMetricAcceptCreateForm.patchValue({
      status: statusId,
    });

    if (isChecked) {
      this.selectedResidualImpact = this.selectedRiskImpact;
      this.selectedResidualLikelihood = this.selectedRiskLikelihood;
      this.residualRiskScore = this.inherentRiskScore;
    }
  }

  onFileSelected(event: any) {
    const files = event.target.files;
    if (files?.length) {
      for (let file of files) {
        const fileAreadyUploaded = this.uploadedFiles.some(
          (uploadedFile: any) => {
            return uploadedFile.file_name === file.name;
          }
        );
        const fileAlreadyInUplaodNew = this.uploadFiles.some(
          (uplaodFile: any) => {
            return uplaodFile.name === file.name;
          }
        );
        if (fileAlreadyInUplaodNew) {
          this.toastrService.error(
            `File ${file.name} is already added to upload`
          );
          break;
        } else if (fileAreadyUploaded) {
          this.toastrService.error(`File ${file.name} already exists`);
          break;
        } else {
          this.commonService.validateFileSize(file).subscribe((isValid) => {
            if (!isValid) {
              this.toastrService.error("Please upload less than 50MB");
              return;
            }
            this.uploadFiles.push(file);
          });
        }
      }
      event.target.value = "";
    }
  }

  removeFile(fileIndex: number) {
    if (
      fileIndex !== null &&
      fileIndex >= 0 &&
      fileIndex < this.uploadFiles.length
    ) {
      this.uploadFiles.splice(fileIndex, 1);
    }
  }

  removeUploadedFile(fileId: number, fileIndex: number) {
    let dialog = this.dialog.open(DeletePopupComponent, {
      data: this.uploadedFiles[fileIndex].file_name,
    });

    dialog.afterClosed().subscribe((res: any) => {
      if (res) {
        this.riskService.deleteFile(fileId).subscribe(
          (res: any) => {
            this.uploadedFiles.splice(fileIndex, 1);
            this.toastrService.success("File removed");
          },
          (err: any) => {
            this.toastrService.error("Failed to remove file!");
          }
        );
      }
    });
  }

  downloadRiskFile(fileId: number, fileIndex: number) {
    this.riskService.downloadFile(fileId).subscribe(
      (res: any) => {
        const downloadLink = document.createElement("a");
        downloadLink.href = window.URL.createObjectURL(res);
        downloadLink.setAttribute(
          "download",
          this.uploadedFiles[fileIndex].file_name
        );
        document.body.appendChild(downloadLink);
        downloadLink.click();
        this.toastrService.success("File downloaded successfully");
      },
      (err: any) => {
        this.toastrService.error("Unable to download file");
      }
    );
  }

  getFunctionName(id: any) {
    return this.mitigationFunctions.find((f: any) => f.id === id)?.display_name;
  }

  createControlRow(data: any = {}) {
    return this.fb.group({
      id: [data.id || null],
      description: [data.description || ""],
      master_risk_control_id: [data.master_risk_control || null],
      type: [data.type?.id || data.type || null],
      modified: [false],
      _originalDescription: [null], // tracks the original selected text
    });
  }

  onControlSelected(option: any, controlGroup: any) {
    controlGroup.patchValue({
      master_risk_control_id: option.id,
      modified: false,
      _originalDescription: option.description,
    });
  }

  onControlInput(controlGroup: any) {
    const original = controlGroup.get("_originalDescription")?.value;
    if (original === null) return; // case (3) — free typed, no selection made

    const current = controlGroup.get("description")?.value;
    controlGroup.patchValue(
      {
        modified: current !== original,
      },
      { emitEvent: false }
    );
  }

  addPreventiveControl() {
    this.preventiveControls.push(this.createControlRow());
  }

  removePreventiveControl(index: number) {
    const item = this.preventiveControls.at(index).value;

    if (item?.id) {
      this.deletedControlIds.push(item.id);
    }

    this.preventiveControls.removeAt(index);

    if (this.preventiveControls.length === 0) {
      this.preventiveControls.push(this.createControlRow());
    }
  }

  addDetectiveControl() {
    this.detectiveControls.push(this.createControlRow());
  }

  removeDetectiveControl(index: number) {
    const item = this.detectiveControls.at(index).value;

    if (item?.id) {
      this.deletedControlIds.push(item.id);
    }

    this.detectiveControls.removeAt(index);

    if (this.detectiveControls.length === 0) {
      this.detectiveControls.push(this.createControlRow());
    }
  }

  getRiskImpactList() {
    this.riskService.getRiskImpactList().subscribe((res: any) => {
      this.riskImpactList = res || [];
    });
  }

  getRiskLikelihoodList() {
    this.riskService.getRiskLikelihoodList().subscribe((res: any) => {
      this.riskLikelihoodList = res || [];
    });
  }

  calculateRiskScore() {
    if (this.selectedRiskImpact && this.selectedRiskLikelihood) {
      const impactScore = Number(
        this.selectedRiskImpact.name || this.selectedRiskImpact.id
      );
      const likelihoodScore = Number(
        this.selectedRiskLikelihood.name || this.selectedRiskLikelihood.id
      );

      this.inherentRiskScore = impactScore * likelihoodScore;
    } else {
      this.inherentRiskScore = null;
    }
  }

  onImpactChange(impactId: number) {
    this.selectedRiskImpact =
      this.riskImpactList.find((i) => i.id === impactId) || null;
    this.calculateRiskScore();
  }

  onLikelihoodChange(likelihoodId: number) {
    this.selectedRiskLikelihood =
      this.riskLikelihoodList.find((l) => l.id === likelihoodId) || null;
    this.calculateRiskScore();
  }

  setRiskScoreFromRes() {
    if (!this.res) return;

    if (this.res?.risk_impact) {
      this.selectedRiskImpact = this.riskImpactList.find(
        (i) => i.id === this.res.risk_impact.id
      );
    }

    if (this.res?.risk_likelihood) {
      this.selectedRiskLikelihood = this.riskLikelihoodList.find(
        (l) => l.id === this.res.risk_likelihood.id
      );
    }

    if (this.res?.inherent_risk_score != null) {
      this.inherentRiskScore = this.res.inherent_risk_score;
    } else {
      this.calculateRiskScore();
    }

    if (this.res?.residual_risk_impact) {
      this.selectedResidualImpact = this.riskImpactList.find(
        (i) => i.id === this.res.residual_risk_impact.id
      );
    }
    if (this.res?.residual_risk_likelihood) {
      this.selectedResidualLikelihood = this.riskLikelihoodList.find(
        (l) => l.id === this.res.residual_risk_likelihood.id
      );
    }
    if (this.res?.residual_risk_score != null) {
      this.residualRiskScore = this.res.residual_risk_score;
    } else {
      this.calculateResidualRiskScore();
    }
  }
  getRiskScoreColor(): string {
    if (!this.inherentRiskScore) return "#bebebf";
    if (this.inherentRiskScore <= 7) return "green";
    if (this.inherentRiskScore <= 14) return "orange";
    return "red";
  }

  calculateResidualRiskScore() {
    if (this.selectedResidualImpact && this.selectedResidualLikelihood) {
      const impactScore = Number(
        this.selectedResidualImpact.name || this.selectedResidualImpact.id
      );
      const likelihoodScore = Number(
        this.selectedResidualLikelihood.name ||
        this.selectedResidualLikelihood.id
      );

      this.residualRiskScore = impactScore * likelihoodScore;
    } else {
      this.residualRiskScore = null;
    }
  }

  onResidualImpactChange(impactId: number) {
    this.selectedResidualImpact = this.riskImpactList.find(
      (i) => i.id === impactId
    );
    this.calculateResidualRiskScore();
  }

  onResidualLikelihoodChange(likelihoodId: number) {
    this.selectedResidualLikelihood = this.riskLikelihoodList.find(
      (l) => l.id === likelihoodId
    );
    this.calculateResidualRiskScore();
  }

  getResidualRiskScoreColor(): string {
    if (!this.residualRiskScore) return "#bebebf";
    if (this.residualRiskScore <= 7) return "green";
    if (this.residualRiskScore <= 14) return "orange";
    return "red";
  }

  get hasActions(): boolean {
    return !!(
      this.res?.risk_mitigation?.length &&
      this.res.risk_mitigation.some((m: any) => m.risk_mitigation?.action)
    );
  }

  get allMitigationTasksClosed(): boolean {
    const controls = this.riskMetricCreateForm?.controls;
    if (!controls || controls.length === 0) return false;
    return controls.every(
      (ctrl: any) => ctrl.get('status')?.value === 'Closed'
    );
  }

  getMaxScore(): number {
    const maxImpact = Math.max(
      ...this.riskImpactList.map((i) => Number(i.name))
    );
    const maxLikelihood = Math.max(
      ...this.riskLikelihoodList.map((l) => Number(l.name))
    );
    return maxImpact * maxLikelihood;
  }

  getScoreColor(score: number): string {
    const maxScore = this.getMaxScore();
    const range = maxScore / 3;
    if (score <= range) return "#4caf50";
    if (score <= range * 2) return "#fbc02d";
    return "#f44336";
  }

  getRiskRanges() {
    const max = this.getMaxScore();
    const range = max / 3;

    return {
      low: `1 – ${Math.ceil(range)}`,
      medium: `${Math.ceil(range) + 1} – ${Math.ceil(range * 2)}`,
      high: `${Math.ceil(range * 2) + 1} – ${max}`,
    };
  }

  isSelectedCell(impactId: number, likelihoodId: number): boolean {
    return (
      this.selectedRiskImpact?.id === impactId &&
      this.selectedRiskLikelihood?.id === likelihoodId
    );
  }

  getRiskScore(impact: string, likelihood: string): number {
    return Number(impact) * Number(likelihood);
  }

  getFilteredControls(type: "preventive" | "detective"): any[] {
    return this.riskControlOptions.filter((c) => c.control_type === type);
  }

  displayControl(option: any): string {
    return option?.description ?? option ?? "";
  }
}
